import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import IconSettingSupport from 'assets/customIcon/IconSettingSupport';

// Store
import usePortfolioDetailStore from 'global/Securities/stores/usePortfolioDetailStore';
import useEmittenInfoStore from 'global/Securities/stores/useEmittenInfoStore';
import tradingDataStore from 'lib/stores/tradingData';

// Utils
import { formatNumber } from 'utils/number';

// Component
import Image from 'global/Image';
import SkeletonWrapper from 'global/Securities/components/SkeletonWrapper';
import { handleClickSupport } from 'utils/crisp';
import { DataSource } from '../DetailModal/InfoTable';
import PortfolioAllocation from './PortfolioAllocation';

import { PortfolioSkeletonBlock, PortfolioInfoTable } from './styled';

interface ModalDetailProps {
  symbol?: string;
}

const ModalDetail = ({ symbol }: ModalDetailProps) => {
  const { portfolioData } = tradingDataStore((s) => ({
    portfolioData: s.portfolio.data,
  }));
  const { selectedPortfolioDetail, isPortfolioDetailLoading } =
    usePortfolioDetailStore((s) => ({
      selectedPortfolioDetail: s.data,
      isPortfolioDetailLoading: s.isLoading,
    }));

  const isCompanyLoading = useEmittenInfoStore((s) => s.isLoading);

  const {
    amount_invested: amountInvested,
    available_share: availableShare,
    exercise_data: exerciseData,
    bond,
    info,
  } = selectedPortfolioDetail || {};

  const { equity } = portfolioData || {};

  const portfolioDataSource: DataSource[] = [
    {
      label: <Text data-cy="invested-label">Invested</Text>,
      value: <Text data-cy="invested-content">{amountInvested}</Text>,
    },
    {
      label: <Text data-cy="exercise-price-label">Exercise Price</Text>,
      value: (
        <Text data-cy="exercise-price-content">
          {formatNumber(exerciseData?.price, true, '0,0.00')}
        </Text>
      ),
    },
    {
      label: <Text data-cy="shares-label">Shares</Text>,
      value: <Text data-cy="shares-content">{availableShare}</Text>,
    },
    {
      label: <Text data-cy="maturity-label">Bond Maturity</Text>,
      value: <Text data-cy="maturity-content">{bond?.maturity}</Text>,
    },
  ];
  const bondDataSource: DataSource[] = [
    {
      label: <Text data-cy="rate-year-label">Coupon Rate / Year</Text>,
      value: <Text data-cy="rate-year-content">{bond?.coupon?.year_rate}</Text>,
    },
    {
      label: <Text data-cy="payment-date-label">Coupon Payment Date</Text>,
      value: (
        <Text data-cy="payment-date-content">{bond?.coupon?.payment_date}</Text>
      ),
    },
    {
      label: <Text data-cy="distribution-label">Coupon Distribution</Text>,
      value: (
        <Text data-cy="distribution-content">{bond?.coupon?.distribution}</Text>
      ),
    },
  ];

  return (
    <>
      <SkeletonWrapper
        skeleton={<PortfolioSkeletonBlock height={296} />}
        loading={isPortfolioDetailLoading || isCompanyLoading}
      >
        <PortfolioInfoTable dataSource={portfolioDataSource} />
        <PortfolioInfoTable dataSource={bondDataSource} />
      </SkeletonWrapper>

      <SkeletonWrapper
        skeleton={<PortfolioSkeletonBlock height={56} />}
        loading={isPortfolioDetailLoading}
      >
        <PortfolioAllocation
          unrealisedMarketValue={amountInvested}
          equity={equity}
        />
      </SkeletonWrapper>
      <Flex
        style={{
          backgroundColor: '#f2f1fe',
          padding: '10px',
          marginBottom: '30px',
        }}
      >
        <Image
          src="/icon/info.svg"
          width="10px"
          height="10px"
          style={{ margin: '4px' }}
        />
        <Text size="13px">{info?.[0]}</Text>
      </Flex>

      <Button
        block
        height="45px"
        type="outline-primary"
        icon={<IconSettingSupport />}
        onClick={handleClickSupport}
      >
        <Text color="inherit" weight={600}>
          Hubungi Support
        </Text>
      </Button>
    </>
  );
};

export default ModalDetail;
